export default {
    attachmentsList: {
        remove: 'remove',
        addButton: '+ Add attachment',
        limitReached: 'Limit reached (20)',
        addTitle: 'Add attachment',
        urlLabel: 'URL',
    },
}
